export const YupValidationMessages = {
    REQUIRED: 'Obrigatório',
};
